import TTask from 'lib/common/types/Task';

export function getTask(tasks: TTask[], taskId: string): TTask | undefined {
  return tasks.find((task) => task.taskId === taskId);
}

export function getTaskContact(tasks: TTask[], taskId: string): connect.Contact | undefined {
  return getTask(tasks, taskId)?.contact;
}
